<script>
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import expandText from "@cclib/functions/quill/expandText.js";
    import * as m from '@app/paraglide/messages.js';

    /* Expand makes the event wider which requires us to add a word to the longest line from a shorter line*/
    const expandEvent = function () {
        if (!eventGroupState[projectState.selected]) {
            return;
        }

        if (
            !eventGroupState[projectState.selected].selected ||
            eventGroupState[projectState.selected].selected.length === 0
        ) {
            return;
        }

        eventGroupState[projectState.selected].selected.forEach(
            (eventIndex, selectedEventIndex) => {
                if (
                    !eventGroupState[projectState.selected].events[eventIndex]
                        .text
                ) {
                    return;
                }

                try {
                    eventGroupState[projectState.selected].events[
                        eventIndex
                    ].text = expandText(
                        eventGroupState[projectState.selected].events[
                            eventIndex
                        ].text, eventGroupState[projectState.selected].maxChars
                    );

                    if (selectedEventIndex === 0 && window.quillEditor) {
                        if (
                            window.quillEditor.getSemanticHTML() !== eventGroupState[projectState.selected].events[eventIndex].text
                        ) {
                            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
                            window.quillEditor.setContents(delta, "silent");
                            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");
                        }
                    }
                } catch (err) {
                    console.error(err);
                }
            }
        );

        insertHistoryAction({
            name: "expand event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });
    };
</script>

<li class="nav-item" title={m.expand_title()}>
    <a
        class="nav-link"
        href="#!/"
        id="expand-event-btn"
        role="button"
        aria-label={m.expand_aria_label()}
        aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        class:disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        onclick={expandEvent}
    ><i class="bi bi-distribute-vertical"></i></a>
</li>
